<div class="am-modal-internal">
    <div class="am-space"></div>
    <div class="am-close-div bg-am-medium-blue">
        <button type="button" class=" text-am-white am-close-x" (click)="closeModal()">
            <img src="../../../../assets/images/close.svg" alt="close">
        </button>
        </div>
    <div class="am-img-alert">
        <app-am-qrcode></app-am-qrcode>
    </div>
    <div class="modal-title txt-Garnett-Regular-42">
        <p>{{  'modalRefund.titleModRef' | translate }}</p>
    </div>
    <div class="modal-subtitle txt-Garnett-Regular-24">
        <p>{{  'modalRefund.subtitleModRef' | translate }}</p>
    </div>
</div>
